import PropTypes from "prop-types";

function FlagIcon({ country, size }) {
  let svg;

  switch (country) {
    case "en": // Великобритания
      svg = (
        <svg
          width={size}
          height={size}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 60 40"
          fill="none"
        >
          <g clipPath="url(#clip0_1608_36)">
            <g clipPath="url(#clip1_1608_36)">
              <mask
                id="mask0_1608_36"
                maskUnits="userSpaceOnUse"
                x="-10"
                y="0"
                width="80"
                height="40"
              >
                <path d="M-10 0V40H70V0H-10Z" fill="white" />
              </mask>
              <g mask="url(#mask0_1608_36)">
                <path d="M-10 0V40H70V0H-10Z" fill="#012169" />
                <path d="M-10 0L70 40L-10 0ZM70 0L-10 40L70 0Z" fill="black" />
                <path d="M-10 0L70 40M70 0L-10 40" stroke="white" strokeWidth="8" />
                <mask
                  id="mask1_1608_36"
                  maskUnits="userSpaceOnUse"
                  x="-10"
                  y="0"
                  width="80"
                  height="40"
                >
                  <path
                    d="M30 20H70V40L30 20ZM30 20V40H-10L30 20ZM30 20H-10V0L30 20ZM30 20V0H70L30 20Z"
                    fill="white"
                  />
                </mask>
                <g mask="url(#mask1_1608_36)">
                  <path d="M-10 0L70 40L-10 0ZM70 0L-10 40L70 0Z" fill="black" />
                  <path d="M-10 0L70 40M70 0L-10 40" stroke="#C8102E" strokeWidth="5.33333" />
                </g>
                <path d="M30 0V40V0ZM-10 20H70H-10Z" fill="black" />
                <path d="M30 0V40M-10 20H70" stroke="white" strokeWidth="13.3333" />
                <path d="M30 0V40V0ZM-10 20H70H-10Z" fill="black" />
                <path d="M30 0V40M-10 20H70" stroke="#C8102E" strokeWidth="8" />
              </g>
            </g>
          </g>
          <rect
            x="0.333333"
            y="0.333333"
            width="59.3333"
            height="39.3333"
            stroke="black"
            strokeOpacity="0.2"
            strokeWidth="0.666667"
          />
          <defs>
            <clipPath id="clip0_1608_36">
              <rect width="60" height="40" fill="white" />
            </clipPath>
            <clipPath id="clip1_1608_36">
              <rect width="80" height="40" fill="white" transform="translate(-10)" />
            </clipPath>
          </defs>
        </svg>
      );
      break;

    case "am": // Армения
      svg = (
        <svg width={size} height={size} viewBox="0 0 640 480" xmlns="http://www.w3.org/2000/svg">
          <rect width="640" height="160" fill="#D90012" />
          <rect y="160" width="640" height="160" fill="#0033A0" />
          <rect y="320" width="640" height="160" fill="#F2A800" />
        </svg>
      );
      break;

    case "ru": // Россия
      svg = (
        <svg width={size} height={size} viewBox="0 0 640 480" xmlns="http://www.w3.org/2000/svg">
          <rect width="640" height="160" fill="#fff" />
          <rect y="160" width="640" height="160" fill="#0039A6" />
          <rect y="320" width="640" height="160" fill="#D52B1E" />
        </svg>
      );
      break;

    default:
      svg = null;
  }

  return svg;
}

// Default props
FlagIcon.defaultProps = {
  size: "24px",
};

// PropTypes
FlagIcon.propTypes = {
  country: PropTypes.oneOf(["en", "am", "ru"]).isRequired,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default FlagIcon;
